"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildCloudinaryLandscapeUrl = buildCloudinaryLandscapeUrl;
exports.buildCloudinarySquareUrl = buildCloudinarySquareUrl;
exports.optimizeCloudinaryUrl = optimizeCloudinaryUrl;
exports.buildCloudinarySignatureUrl = buildCloudinarySignatureUrl;
const CLOUDINARY_UPLOAD_SEGMENT = "/image/upload/";
const OPTIMIZATION_PARAMS = "f_auto,q_auto/";
// f_auto would turn a GIF into an animated WebP, which email clients like Outlook cannot render.
const GIF_OPTIMIZATION_PARAMS = "q_auto/";
const GIF_EXTENSION_PATTERN = /\.gif(\?|#|$)/i;
const LANDSCAPE_CROP_PARAMS = "c_fill,ar_16:9,g_auto,w_1200/f_auto,q_auto/";
const SQUARE_CROP_PARAMS = "c_fill,ar_1:1,g_auto,w_600/f_auto,q_auto/";
// Injects a Cloudinary transform right after `/image/upload/`. Non-Cloudinary URLs and URLs that
// already carry the transform are returned unchanged (we never store the transform, only deliver it).
function injectCloudinaryTransform(url, transform) {
    if (!url) {
        return null;
    }
    if (!url.includes("res.cloudinary.com")) {
        return url;
    }
    if (url.includes(transform)) {
        return url;
    }
    const uploadIndex = url.indexOf(CLOUDINARY_UPLOAD_SEGMENT);
    if (uploadIndex === -1) {
        return url;
    }
    const insertAt = uploadIndex + CLOUDINARY_UPLOAD_SEGMENT.length;
    return url.slice(0, insertAt) + transform + url.slice(insertAt);
}
function buildCloudinaryLandscapeUrl(url) {
    return injectCloudinaryTransform(url, LANDSCAPE_CROP_PARAMS);
}
function buildCloudinarySquareUrl(url) {
    return injectCloudinaryTransform(url, SQUARE_CROP_PARAMS);
}
// Transparent padding kept around the trimmed signature, in source pixels.
const SIGNATURE_PADDING_PX = 40;
const BACKGROUND_REMOVAL_PARAMS = `e_background_removal/e_trim/bo_${SIGNATURE_PADDING_PX}px_solid_transparent/f_png/`;
function optimizeCloudinaryUrl(url) {
    if (!url) {
        return null;
    }
    if (!url.includes("res.cloudinary.com")) {
        return url;
    }
    if (url.includes("f_auto") || url.includes("q_auto")) {
        return url;
    }
    const uploadIndex = url.indexOf(CLOUDINARY_UPLOAD_SEGMENT);
    if (uploadIndex === -1) {
        return url;
    }
    const insertAt = uploadIndex + CLOUDINARY_UPLOAD_SEGMENT.length;
    const optimizationParams = GIF_EXTENSION_PATTERN.test(url) ? GIF_OPTIMIZATION_PARAMS : OPTIMIZATION_PARAMS;
    return url.slice(0, insertAt) + optimizationParams + url.slice(insertAt);
}
// Injects the AI background-removal effect into a Cloudinary delivery URL so signatures
// are detoured on the fly. Original URL stays the source of truth; we never store the transform.
function buildCloudinarySignatureUrl(url) {
    if (!url) {
        return null;
    }
    if (!url.includes("res.cloudinary.com")) {
        return url;
    }
    if (url.includes("e_background_removal")) {
        return url;
    }
    const uploadIndex = url.indexOf(CLOUDINARY_UPLOAD_SEGMENT);
    if (uploadIndex === -1) {
        return url;
    }
    const insertAt = uploadIndex + CLOUDINARY_UPLOAD_SEGMENT.length;
    return url.slice(0, insertAt) + BACKGROUND_REMOVAL_PARAMS + url.slice(insertAt);
}
